import React, { useRef, useCallback, useState, useEffect, ChangeEvent } from 'react';
import Grid from '@material-ui/core/Grid';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { FiCamera } from 'react-icons/fi';
import no_image from '../../../../../../../../../assets/no_image.png';
import InputLogged from '../../../../../../../../../components/InputLogged';
import Select from '../../../../../../../../../components/Select';
import api from '../../../../../../../../../services/api';

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { RiCloseLine } from 'react-icons/ri';
import { FaRegTrashAlt } from 'react-icons/fa';

import { useSimpleProduct } from '../../../../../../../../../hooks/newSimpleProduct';
import { useToast } from '../../../../../../../../../hooks/toast';

import {
  TabWrapper,
  AddButton,
  ButtonAction,
  QtdItemContainer,
  TrashBtnWrapper,
} from '../../../../../drawer_styles';
import { SubmitButtonWrapper, ModalWrapper } from '../../../../../../styles';
import material_styles from '../../../../../drawer_styles/material_styles';
import {
  FormWrapper,
  NewImg,
  LabelWrapper
} from '../../../../../drawer_styles';

interface EditItensComplementosProps {
  index_complemento: number;
}

interface ItemComplementoType {
  codigo_complemento?: string;
  descricao: string;
  tipo: number;
  preco: number;
  imagem?: File;
  produto_id?: number;
  index_complemento: number;
  qtd_min: number;
  qtd_max: number;
}

interface OptionType {
  id: string;
  value: string;
  label: string;
}

interface QtdComplementos {
  index: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

const Complementos: React.FC<EditItensComplementosProps> = ({
  index_complemento,
}) => {
  const [qtdComplementos, setQtdComplementos] = useState<QtdComplementos[]>([]);
  const [materiasPrimas, setMateriasPrimas] = useState<OptionType[]>([]);
  // const [materiasPrimasSelecionadas, setMateriasPrimasSelecionadas] = useState<OptionType[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmacaoModal, setConfirmacaoModal] = useState(false);
  const [itensDoMesmoComplemento, setItensDoMesmoComplemento] = useState<ItemComplementoType[]>([]);

  const {
    itensComplemento,
    updateItensComplemento,
    handleSetEditComplementoDrawerWasClosed,
  } = useSimpleProduct();
  const { addToast } = useToast();

  const classes = material_styles();
  const modalClasses = useStyles();

  const formRef = useRef<FormHandles>(null);

  useEffect(() => {
    function loadInitialData() {
      let indexValue = 0;
      const itensFinded: ItemComplementoType[] = [];
      const indexes: QtdComplementos[] = [];

      for (let i = 0; i < itensComplemento.length; i += 1) {
        if (itensComplemento[i].index_complemento === index_complemento) {
          const objFinded = {...itensComplemento[i]};
          itensFinded.push(objFinded);

          indexes.push({ index: indexValue });
          indexValue += 1;
        }
      }

      setQtdComplementos([...indexes]);
      setItensDoMesmoComplemento([...itensFinded]);
    }

    async function loadMateriasPrimas(): Promise<void> {
      const response = await api.get(`/produto/tipo/${2}`);

      const optionItems: OptionType[] = [];

      response.data.map((item: any) => {
        const option = {
          id: item.id,
          value: item.id,
          label: item.descricao,
        };

        optionItems.push(option);
      });

      setMateriasPrimas([...optionItems]);
    }

    loadInitialData();
    loadMateriasPrimas();
  }, []);

  const handleToggleModal = useCallback((value: boolean) => {
    setModalOpen(value);
  }, []);

  const handleInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, item_index: number, input_name: string) => {
      const newStateItens = [...itensDoMesmoComplemento];

      switch (input_name) {
        case 'descricao':
          newStateItens[item_index].descricao = e.target.value;
          setItensDoMesmoComplemento([...newStateItens]);

          return;
        case 'preco':
          newStateItens[item_index].preco = Number(e.target.value);
          setItensDoMesmoComplemento([...newStateItens]);

          return;
        case 'codigo_complemento':
          newStateItens[item_index].codigo_complemento = e.target.value;
          setItensDoMesmoComplemento([...newStateItens]);

          return;
      }
    },
    [itensDoMesmoComplemento]
  );

  const handleSetQtd = useCallback(
    (input: string, operacao: string, index: number) => {
      const newQtdItem = [...itensDoMesmoComplemento];

      if (operacao === 'increment') {
        input === 'qtdMin'
          ? newQtdItem[index].qtd_min = newQtdItem[index].qtd_min + 1
          : newQtdItem[index].qtd_max = newQtdItem[index].qtd_max + 1
      } else if (operacao === 'decrement') {
        if (input === 'qtdMin') {
          if (newQtdItem[index].qtd_min - 1 < 0) return;

          newQtdItem[index].qtd_min = newQtdItem[index].qtd_min - 1;
        }

        if (input === 'qtdMax') {
          if (newQtdItem[index].qtd_max - 1 < 0) return;

          newQtdItem[index].qtd_max = newQtdItem[index].qtd_max - 1;
        }
      }

      setItensDoMesmoComplemento([...newQtdItem]);
    }, [itensDoMesmoComplemento]
  );

  const handleImgChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, item_index: number): void => {
      if (e.target.files) {
        const newStateItens = [...itensDoMesmoComplemento];
        newStateItens[item_index].imagem = e.target.files[0];

        setItensDoMesmoComplemento([...newStateItens]);

        return;
      }
    },
    [itensDoMesmoComplemento],
  );

  const handleRemoveItem = useCallback((index: number) => {
    const itensUpdated = [...itensDoMesmoComplemento];
    const qtdUpdated = [...qtdComplementos];

    if (itensUpdated.length - 1 === 0) {
      addToast({
        type: 'error',
        title: 'Exclusão negada',
        description: 'Seu grupo de complementos deve ter pelo menos um item.'
      });

      return;
    }

    itensUpdated.splice(index, 1);
    qtdUpdated.splice(index, 1);

    setItensDoMesmoComplemento([...itensUpdated]);
    setQtdComplementos([...qtdUpdated]);
  }, [itensDoMesmoComplemento, addToast, qtdComplementos]);

  const handleAddComplemento = useCallback(() => {
    setItensDoMesmoComplemento([
      ...itensDoMesmoComplemento,
      {
        descricao: '',
        preco: 0,
        tipo: 1,
        index_complemento,
        qtd_min: 0,
        qtd_max: 0,
      }
    ]);

    setQtdComplementos([
      ...qtdComplementos,
      {
        index: qtdComplementos[qtdComplementos.length - 1].index + 1,
      },
    ]);
  }, [qtdComplementos]);

  const handleSubmit = useCallback((data: any) => {
    const itensUpdated: ItemComplementoType[] = [];

    itensComplemento.map((item) => {
      if (!item.produto_id && !confirmacaoModal) {
        setModalOpen(true);
        return;
      }

      if (item.index_complemento !== index_complemento) {
        itensUpdated.push(item);
      }
    });

    if (confirmacaoModal) {
      let error = false;

      itensDoMesmoComplemento.map((item): void => {
        if (item.qtd_min > item.qtd_max) {
          addToast({
            type: 'error',
            title: 'Quantidade inválida.',
            description: `A quantidade mínima do item ${item.descricao} deve ser maior que a quantidade máxima.`,
          });

          error = true;
          return;
        }
      });

      if (error) return;

      itensUpdated.push(...itensDoMesmoComplemento);
      updateItensComplemento(itensUpdated);

      addToast({
        type: 'info',
        title: 'Itens salvos.',
      });
      setConfirmacaoModal(false);
      handleSetEditComplementoDrawerWasClosed(true);
    }
  }, [
    itensComplemento,
    itensDoMesmoComplemento,
    confirmacaoModal,
    handleSetEditComplementoDrawerWasClosed,
  ]);

  return (
    <TabWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.noPaddingBot}>
          <AddButton type="button" onClick={handleAddComplemento}>
            + Adicionar Complemento
          </AddButton>
        </Grid>

        <Grid item xs={12}>
          <Form ref={formRef} onSubmit={handleSubmit}>
            {qtdComplementos.map((item) => (
              <>
                {itensDoMesmoComplemento[item.index] && (
                  <FormWrapper className="form_item" key={item.index}>
                    <Grid container spacing={3}>
                      <Grid item xs={3}>
                        <NewImg>
                          <img
                            src={
                              itensDoMesmoComplemento[item.index].imagem
                                ? URL.createObjectURL(itensDoMesmoComplemento[item.index].imagem)
                                : no_image
                              }
                            alt="Item Complemento"
                          />

                          <label htmlFor={`complemento_img`}>
                            <FiCamera size={20} />
                            <input
                              type="file"
                              id={`complemento_img`}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                handleImgChange(e, item.index)
                              }
                            />
                          </label>
                        </NewImg>
                      </Grid>

                      <Grid item xs={9}>
                        <Grid container spacing={1}>
                          <Grid item xs={6} className={classes.noPaddingTop}>
                            <LabelWrapper>
                              <span>Nome do complemento</span>
                            </LabelWrapper>

                            <InputLogged
                              name={`descricao`}
                              placeholder="Digite o nome"
                              value={itensDoMesmoComplemento[item.index].descricao}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                handleInputChange(e, item.index, 'descricao')
                              }
                            />
                          </Grid>

                          <Grid item xs={5} className={classes.noPaddingTop}>
                            <LabelWrapper>
                              <span>Matéria Prima</span>
                            </LabelWrapper>

                            <Select
                              name={`produto_id`}
                              placeholder="Matéria prima"
                              options={materiasPrimas}
                            />
                          </Grid>

                          <Grid item xs={1} className={classes.noPaddingTop}>
                            <TrashBtnWrapper>
                              <button
                                type="button"
                                onClick={() => handleRemoveItem(item.index)}
                              >
                                <FaRegTrashAlt size={20} />
                              </button>
                            </TrashBtnWrapper>
                          </Grid>

                          <Grid item xs={3} className={classes.noPaddingTop}>
                            <LabelWrapper>
                              <span>Preço</span>
                            </LabelWrapper>

                            <InputLogged
                              name={`preco`}
                              type="number"
                              placeholder="Preco"
                              value={itensDoMesmoComplemento[item.index].preco}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                handleInputChange(e, item.index, 'preco')
                              }
                            />
                          </Grid>

                          <Grid item xs={3} className={classes.noPaddingTop}>
                            <LabelWrapper>
                              <span>Código PDV</span>
                            </LabelWrapper>

                            <InputLogged
                              name={`codigo_complemento`}
                              placeholder="Código"
                              value={itensDoMesmoComplemento[item.index].codigo_complemento}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                handleInputChange(e, item.index, 'codigo_complemento')
                              }
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <QtdItemContainer>
                              <div className="control-wrapper">
                                <span>Mínimo</span>

                                <div>
                                  <button
                                    type="button"
                                    className="decrement"
                                    onClick={() => handleSetQtd('qtdMin', 'decrement', item.index)}
                                  >
                                    -
                                  </button>

                                  <input
                                    type="number"
                                    min="0"
                                    readOnly
                                    value={itensDoMesmoComplemento[item.index].qtd_min}
                                  />

                                  <button
                                    type="button"
                                    className="increment"
                                    onClick={() => handleSetQtd('qtdMin', 'increment', item.index)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </QtdItemContainer>
                          </Grid>

                          <Grid item xs={3}>
                            <QtdItemContainer>
                              <div className="control-wrapper">
                                <span>Máximo</span>

                                <div>
                                  <button
                                    type="button"
                                    className="decrement"
                                    onClick={() => handleSetQtd('qtdMax', 'decrement', item.index)}
                                  >
                                    -
                                  </button>

                                  <input
                                    type="number"
                                    min="0"
                                    readOnly
                                    value={itensDoMesmoComplemento[item.index].qtd_max}
                                  />

                                  <button
                                    type="button"
                                    className="increment"
                                    onClick={() => handleSetQtd('qtdMax', 'increment', item.index)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </QtdItemContainer>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Modal
                      className={modalClasses.modal}
                      open={modalOpen}
                      onClose={() => handleToggleModal(false)}
                      closeAfterTransition
                      BackdropComponent={Backdrop}
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Fade in={modalOpen}>
                        <ModalWrapper>
                          <div className="header">
                            <h1>Confirmação</h1>

                            <button
                              type="button"
                              onClick={() => handleToggleModal(false)}
                            >
                              <RiCloseLine size={30} />
                            </button>
                          </div>

                          <div className="description">
                            <span>
                              Complementos sem matéria prima não terão seu estoque controlado.
                            </span>
                          </div>

                          <div className="btnActions">
                            <button
                              type="button"
                              className="confirm"
                              onClick={() => {
                                setConfirmacaoModal(true);
                                handleToggleModal(false);
                                setTimeout(() => formRef.current?.submitForm(), 0);
                              }}
                            >
                              Ok, sem problemas
                            </button>

                            <button
                              type="button"
                              className="cancel"
                              onClick={() => handleToggleModal(false)}
                            >
                              Cancelar
                            </button>
                          </div>
                        </ModalWrapper>
                      </Fade>
                    </Modal>
                  </FormWrapper>
                )}
              </>
            ))}

            <Grid item xs={12} className={classes.noPaddingBot}>
              <SubmitButtonWrapper>
                <ButtonAction
                  type="button"
                  className="cancel"
                  onClick={() => handleSetEditComplementoDrawerWasClosed(true)}
                >
                  Cancelar
                </ButtonAction>

                <ButtonAction
                  type="submit"
                  className="submit"
                  onClick={handleSubmit}
                >
                  Salvar
                </ButtonAction>
              </SubmitButtonWrapper>
            </Grid>
          </Form>
        </Grid>
      </Grid>
    </TabWrapper>
  );
};

export default Complementos;
